import { Popover, PopoverAction, usePopoverState } from 'components/Popover';
import { IconCheckThin, IconChevronDown, IconChevronUp } from 'components/Icons';
import { baseTheme, breakpoints } from 'styles/utils';
import { useListWorkspaces, useLoggedInUserId, useSwitchUserAccount } from 'modules/Auth/hooks';
import { css, cx } from '@linaria/core';
import { ellipsis } from 'polished';
import { AccountIcon } from 'components/Navbar/components/Account';
import { useRouter } from 'next/router';
import { extractUserOrOrgId } from 'utils/urlUtils';
import { ExtendedLinkProps, Link } from 'components/Link';
import { Portal } from 'reakit';
import { SearchInput } from 'components/Search/SearchInput';
import { useState } from 'react';
import { includes, join, pick, pipe, toLower, trim } from 'rambda';
interface AccountItemProps extends ExtendedLinkProps {
  name: string;
  selected?: boolean;
}
const searchWorkspace = (searchText: string) => {
  const formatText = pipe(trim, toLower);
  const formattedSearchText = formatText(searchText);
  const searchFields: (keyof CF.LocalUser)[] = ['user_id', 'first_name', 'last_name'];
  return pipe(pick(searchFields), Object.values, join(' '), formatText, includes(formattedSearchText));
};
const AccountButton: React.FC<AccountItemProps> = ({
  name,
  selected,
  ...rest
}) => {
  return <Link className={cx(WorkspaceSwitcherStyles.accountButton, selected && 'selected')} data-testid={`account-${name}`} {...rest}>
      <AccountIcon name={name} type="org" iconSize={24} className={WorkspaceSwitcherStyles.thumbnail} />
      <p className={WorkspaceSwitcherStyles.accountButtonName}>{name}</p>
      {selected && <IconCheckThin size={16} color={baseTheme.light.colors.primary} />}
    </Link>;
};
export const WorkspaceSwitcher: React.FC = () => {
  const router = useRouter();
  const loggedInUserId = useLoggedInUserId();
  const switchUserAccount = useSwitchUserAccount();
  const workspaces = useListWorkspaces();
  const [autocompleteSearchText, setAutocompleteSearchText] = useState('');
  const displayUserId = extractUserOrOrgId(router) || loggedInUserId;
  const shouldShowAutocomplete = workspaces.length >= 5;
  const workspacesExcludingSelected = workspaces.filter(workspace => workspace.user_id !== displayUserId);
  const searchWorkspacesExcludingSelected = workspacesExcludingSelected.filter(searchWorkspace(autocompleteSearchText));
  const popover = usePopoverState({
    placement: 'bottom-start'
  });
  const ChevronIcon = popover.visible ? IconChevronUp : IconChevronDown;
  if (!displayUserId) {
    return null;
  }
  return <>
      <PopoverAction className={cx(WorkspaceSwitcherStyles.popoverAction, 'workspace-switcher')} popover={popover} data-testid="account-switcher">
        <AccountIcon name={displayUserId} type="user" iconSize={23} className={WorkspaceSwitcherStyles.thumbnail} />
        <div className={cx(WorkspaceSwitcherStyles.titleWrapper, 'display-user-fullname')}>
          <p className={WorkspaceSwitcherStyles.title} data-testid="fullname">
            {displayUserId}
          </p>
        </div>
        <ChevronIcon size={20} style={{
        minWidth: 20
      }} className="caret-icon" />
      </PopoverAction>

      {/* WORKSPACES... */}
      <Portal>
        <Popover className={cx(WorkspaceSwitcherStyles.workspaces, WorkspaceSwitcherStyles.popover, 'workspace-switcher')} popover={popover} aria-label="Switch page context" data-testid="account-switch-popover" tabIndex={0} modal>
          {/* CURRENTLY VIEWING */}
          <span className={cx(WorkspaceSwitcherStyles.popoverTitle)}>Currently viewing:</span>
          <AccountButton selected name={displayUserId} onClick={popover.hide} href={router} />

          {/* JUMP TO */}
          {workspacesExcludingSelected.length > 0 && <>
              <span className={cx(WorkspaceSwitcherStyles.popoverTitle)}>Jump to:</span>
              {shouldShowAutocomplete && <SearchInput placeholder="Search" value={autocompleteSearchText} setValue={setAutocompleteSearchText} wrapperClassName={WorkspaceSwitcherStyles.searchInput} iconClassName={WorkspaceSwitcherStyles.searchIcon} />}
              {searchWorkspacesExcludingSelected.map(workspace => <AccountButton key={workspace.user_id} name={workspace.user_id} onClick={popover.hide} href={switchUserAccount(workspace.user_id, true)} />)}
            </>}
        </Popover>
      </Portal>
    </>;
};
export const WorkspaceSwitcherStyles = {
  popoverAction: "omponents__SidebarV2__WorkspaceSwitcher_tsx-popoverAction-p1fnyy40",
  popover: "omponents__SidebarV2__WorkspaceSwitcher_tsx-popover-p1rfupay",
  workspaces: "omponents__SidebarV2__WorkspaceSwitcher_tsx-workspaces-w8s8sz3",
  titleWrapper: "omponents__SidebarV2__WorkspaceSwitcher_tsx-titleWrapper-t1tp474u",
  title: "omponents__SidebarV2__WorkspaceSwitcher_tsx-title-tasngmh",
  popoverTitle: "omponents__SidebarV2__WorkspaceSwitcher_tsx-popoverTitle-ps8o0y8",
  avatar: "omponents__SidebarV2__WorkspaceSwitcher_tsx-avatar-avzsw0n",
  thumbnail: "omponents__SidebarV2__WorkspaceSwitcher_tsx-thumbnail-t1g28lvd",
  searchInput: "omponents__SidebarV2__WorkspaceSwitcher_tsx-searchInput-s1d64svt",
  searchIcon: "omponents__SidebarV2__WorkspaceSwitcher_tsx-searchIcon-s14u4fkw",
  accountButton: "omponents__SidebarV2__WorkspaceSwitcher_tsx-accountButton-a1xyw25m",
  accountButtonName: "omponents__SidebarV2__WorkspaceSwitcher_tsx-accountButtonName-a1encew3"
};

require("./WorkspaceSwitcher.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./WorkspaceSwitcher.tsx");